<button
  [type]="type"
  [disabled]="computedDisabled"
  [class]="computedButtonClass"
  [attr.aria-label]="computedAriaLabel"
  [attr.tabindex]="tabIndex"
  >
  @if (loading) {
    <span
      class="p-button-loading-icon pi pi-spinner pi-spin"
      aria-hidden="true"
    ></span>
  }

  @if (!loading && icon) {
    <span
      class="p-button-icon"
      [ngClass]="[icon, iconPositionClass]"
      aria-hidden="true"
    ></span>
  }

  @if (label) {
    <span class="p-button-label">{{ label }}</span>
  }

  @if (badge) {
    <span
      class="p-badge p-component p-button-badge"
      [ngClass]="badgeClass"
      aria-hidden="true"
      >
      {{ badge }}
    </span>
  }
</button>

